"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
/**
 * Text can be used to render any arbitrary text. Given children will be rendered inside a span with the global font
 * style applied.
 */
const Text = (_a) => {
    var _b;
    var { children, variant = 'span', color } = _a, props = __rest(_a, ["children", "variant", "color"]);
    const textProps = {
        span: { variant: 'body1', component: 'span' },
        small: { variant: 'body2', component: 'small' },
    };
    return (react_1.default.createElement(Typography_1.default, Object.assign({}, ((_b = textProps[variant]) !== null && _b !== void 0 ? _b : { variant: 'body1' }), { color: color, "data-testid": props['data-testid'] }), children));
};
exports.default = Text;
//# sourceMappingURL=index.js.map